import { useNavigate } from "react-router-dom";
import useExchangePortalAxios from "../utils/axios";

const useLogout = () => {
  const navigate = useNavigate();
  const ExchangePortalClient = useExchangePortalAxios();


  const logout = async () => {
    await ExchangePortalClient.post(`/v1/Auth/LogOut`, {
      SessionID: sessionStorage.getItem("SessionID"),
    }).finally(()=>{
      sessionStorage.clear();
      navigate("/", { replace: true });
    })
  };

  return {
    logout,
  };
};

export default useLogout;
